import React from 'react';
import '../Assets/Css/partner.css';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import { FaStar } from 'react-icons/fa';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import leftagrow from '../Assets/Image/plant5.png'
import rightagrow from '../Assets/Image/plant4.png'
import { FaSchool, FaHandsHelping } from 'react-icons/fa';
import { GiHerbsBundle } from 'react-icons/gi';
import { Helmet } from 'react-helmet';

export default function Partners() {

  const testimonials = [
  {
    text: "Collaborating with XtraGrow has amplified our outreach and strengthened our grassroots initiatives.",
    role: "— Director, GreenRoots NGO"
  },
  {
    text: "Their commitment to sustainability and education aligns perfectly with our mission.",
    role: "— Program Manager, EcoEdu Foundation"
  },
  {
    text: "XtraGrow is not just a partner — they are a catalyst for real, scalable community impact.",
    role: "— Strategic Lead, AgriConnect"
  },
  {
    text: "Working together, we’ve built awareness campaigns that truly resonate with rural communities.",
    role: "— Project Coordinator, Soil & Soul"
  },
  {
    text: "The transparency and dedication of XtraGrow’s team make them a trusted long-term collaborator.",
    role: "— Regional Head, EarthKind Alliance"
  }
];


  return (
    <div className="mainnav min-vh-100">

      <Helmet>
        <title>Our Partners | XtraGrow Foundation, Inc.</title>
        <meta
          name="description"
          content="XtraGrow Foundation partners with like-minded organizations to promote sustainable agriculture, organic farming education, and community wellness across rural and urban areas."
        />
        <meta
          name="keywords"
          content="XtraGrow partners, organic farming partners, sustainable agriculture collaboration, community health, NGO partnerships, eco-friendly farming, XtraGrow Foundation"
        />
        <meta name="author" content="XtraGrow Foundation, Inc." />
        <link rel="canonical" href="https://xtragrowfoundation.org/partners" />

        {/* Open Graph Meta Tags */}
        <meta property="og:title" content="Our Partners | XtraGrow Foundation" />
        <meta
          property="og:description"
          content="We collaborate with nonprofits, businesses, and individuals to amplify the impact of sustainable agriculture and organic education."
        />
        <meta property="og:url" content="https://xtragrowfoundation.org/partners" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://xtragrowfoundation.org/images/partners-banner.jpg"
        />

        {/* Twitter Card Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Our Partners | XtraGrow Foundation" />
        <meta
          name="twitter:description"
          content="Join forces with XtraGrow Foundation to advance sustainable organic agriculture and education in communities across the nation."
        />
        <meta
          name="twitter:image"
          content="https://xtragrowfoundation.org/images/partners-banner.jpg"
        />
      </Helmet>

      {/* Hero Section */}
      <section className="hero-section2">
        <div className="overlay">
          <h1 data-aos="zoom-in">Partners</h1>
          <p className="text-white" data-aos="zoom-in">Home | Partners</p>
        </div>
      </section>

      {/* Partner Info Section */}
       <Container className="py-5">
          <Row className="justify-content-center">
            <Col md={10}>
              <div className="who-we-are-section p-5 rounded ">
                <h2 className='page-title' data-aos="fade-up">Our  <span style={{ color: '#078825' }}> Partners</span>  </h2>
                <p className="text-center  text-dark" data-aos="zoom-in">
               <span style={{ color: '#036839', fontWeight: 'bold' }}> XTRAGROW</span>
                    <span style={{ color: '#3CB649', fontWeight: 'bold' }}> Foundation, Inc., </span> collaborates with organizations that share our commitment to sustainable agriculture and community health. We welcome partnerships with like-minded entities to amplify our impact and reach more individuals dedicated to promoting Premium Organic farming practices.
                </p>
                <p data-aos="zoom-in">
                  For more information about our initiatives, programs, or partnership opportunities, please contact us.
                </p>
              </div>
            </Col>
          </Row>
        </Container>


      {/* Why Partner With Us */}
    <section className="why-partner-section py-5">
  <div className="container" data-aos="fade-up">
    <h2 className="page-title text-center mb-5">
      Why <span className="green-text">Partner</span> With Us?
    </h2>
    <div className="row justify-content-center">
      <div className="col-md-6">
        <ul className="why-partner-list">
          <li><span>🌱</span> Promote organic, eco-friendly farming across rural and urban areas</li>
          <li><span>📘</span> Co-develop impactful programs in agriculture, health, and education</li>
          <li><span>🤝</span> Access a dedicated network of volunteers and educators</li>
        </ul>
      </div>
      <div className="col-md-6">
        <ul className="why-partner-list">
          <li><span>📣</span> Collaborate on awareness campaigns and training sessions</li>
          <li><span>🌍</span> Make measurable impact on communities through sustainability</li>
           <li><span>💼</span> Gain recognition by aligning with a socially responsible cause</li> 
        </ul>
      </div>
    </div>
  </div>
</section>



      {/* Current Collaborations */}
      {/* Get Involved CTA */}
      <section className="get-involved-section py-5 bg-success text-white">
        <div className="container text-center" data-aos="fade-up">
          <h2 className='page-title mb-3 text-white'>Let’s <span style={{ color: '#ffffff' }}>Grow Together</span></h2>
          <p className="lead">
            Whether you're a nonprofit, a business, or an individual, 
            we invite you to become a catalyst for organic transformation.
           </p>
          <a href="/contact" className="btn-donate">Become a Partner</a>
        </div>
      </section>

      <section className="py-5 testimonial-carousel-section mb-1">
          <div className="container  ">
            <Row className="align-items-end flex-column flex-md-row m-0">
              <Col xs={12} md={2} className="d-flex justify-content-center justify-content-md-start order-2 order-md-1 chocolates-col">
                <img
                  src={leftagrow}
                  alt="crop Left"
                  className="chocolate-image"
                  data-aos="zoom-in" data-aos-delay="100"
                />
              </Col>

              <Col xs={12} md={8} className="text-center order-1 order-md-2" data-aos="zoom-in" data-aos-delay="300">
                <h2 className="page-title text-center mb-4" data-aos="fade-up">
                  Stories <span style={{ color: '#078825' }}>That Inspire</span>
                </h2>
                <p className="text-muted mx-auto" style={{ maxWidth: 700 }}>
                  Inspiring stories from those impacted by our organic farming and education efforts.
                </p>


                <Swiper
                  modules={[Pagination, Autoplay]}
                  spaceBetween={30}
                  slidesPerView={1}
                  pagination={{ clickable: true }}
                  autoplay={{ delay: 3500 }}
                  loop={true}
                >
                  {testimonials.map((item, idx) => (
                    <SwiperSlide key={idx}>
                      <div className="testimonial-slide  text-center  p-3 ">
                        <div className="stars mb-2 ">
                          {[...Array(5)].map((_, i) => (
                            <FaStar key={i} />
                          ))}
                        </div>
                        <p className="testimonial-quote">
                          <span className="quote-mark">“</span>
                          {item.text}
                          <span className="quote-mark">”</span>
                        </p>
                        <p className="author-name">{item.role}</p>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>

              </Col>

              <Col xs={12} md={2} className="d-flex justify-content-center justify-content-md-end order-0 order-md-3 chocolates-col">
                <img
                  src={rightagrow}
                  alt="crop Right"
                  className="chocolateright-image"
                  data-aos="zoom-in" data-aos-delay="200"
                />
              </Col>
            </Row>
          </div>
        </section>

    </div>
  );
}
